import { render, staticRenderFns } from "./UserPermissionModal.vue?vue&type=template&id=18d8124c&scoped=true&"
import script from "./UserPermissionModal.vue?vue&type=script&lang=js&"
export * from "./UserPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionModal.vue?vue&type=style&index=0&id=18d8124c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8124c",
  null
  
)

export default component.exports